import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Observable, of, tap, throwError } from 'rxjs';
import { apiEndpoints } from 'src/app/api-endpoints';
import { CalcEngineRequest, CalcEngineResponse } from './models/calc-engine.model';
import { RequestCacheService } from './cache.service';

@Injectable({
  providedIn: 'root'
})
export class CalcEngineService {
  private apiUrl = environment.apiConfig.baseUri + apiEndpoints.calcEngineApis;
  private calcApis = {
    runCalcEngine: '/run',
  };

  constructor(
    private http: HttpClient,
    private cacheService: RequestCacheService
  ) {}


  /**
   * Retrieves the metric list for the given application.
   * If a caller has marked to use caching, then will check/utilize cache when possible
   * Cache should not be used for real-time data
   */
  runCalcEngine( calcEngineRequest: CalcEngineRequest, useCache: boolean = false ): Observable<CalcEngineResponse> {
    let url = `${this.apiUrl}${this.calcApis.runCalcEngine}`;

    if(useCache){
      // Check if response is cached
      const cachedResponse = this.cacheService.getFromCache(
        url,
        calcEngineRequest
      );

      if (cachedResponse) {
        // If cache exists, return it as an Observable
        return of(cachedResponse);
      }
    }

    // Otherwise, make the HTTP call and cache the result
    return this.http.post<any>(`${this.apiUrl}${this.calcApis.runCalcEngine}`, calcEngineRequest).pipe(
      tap(response => {
        // Save the response to the cache
        if(useCache){
          this.cacheService.setCache(url, calcEngineRequest, response);
        }
      })
    );
  }

}
